<h2
  mat-dialog-title
  style="margin-bottom: 0px !important"
>
  <span>{{ "form.setup_signing_unit" | translate }}</span>
  <button type="button" class="close" aria-label="Close" mat-dialog-close (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>

<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography" style="max-height: 65vh;margin-top: 15px;">

  <mat-expansion-panel  class="mat-elevation-z0" expanded="true">

    <div class="d-flex align-items-end">
      <div style="padding-bottom: 1.5rem;">{{ 'enterprise_contract.select_sign_process' | translate }}</div>
      <mat-form-field class="mx-4" style="width: 20rem;">
        <!-- <mat-label>{{ "procedure.choose_procedure" | translate }}</mat-label> -->
        <mat-select
          name="procedure"
          id="procedure"
          [(ngModel)]="procedureId"
          (selectionChange)="changeProcedure($event)"
        >
          <mat-option>
            <ngx-mat-select-search
              [formControl]="searchCtrl"
              [placeholderLabel]="
                'placeholder.search_procedure' | translate
              "
              [searching]="false"
              [noEntriesFoundLabel]="'analysis.no_data' | translate"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let option of proceduresFilter" [value]="option.id">
            {{ option.procedureName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div style="padding-bottom: 1.5rem;">{{ 'enterprise_contract.note_use_sign_process' | translate }}</div>
      <div [routerLink]="['/home-enterprise/procedure-management']" class="ml-1" style="color: #EE0033; text-decoration:underline; cursor: pointer; padding-bottom: 1.5rem;">{{ 'enterprise_contract.unit_signing_process' | translate }}</div>
    </div>

    <form nz-form>
      <nz-table #editRowTable [nzData]="listOfDataUserSign" [nzFrontPagination]="false" [nzShowPagination]="false"
                class="ant-table-no-placeholder-border-bottom no-ant-table-placeholder" nzBordered>
        <thead>
        <tr>
          <th class="text-center" nzWidth="54px" style="min-width: 54px;">
            {{
              "enterprise_contract.panel_document.table_parties.header.order"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="62%">
            {{
              "enterprise_contract.panel_document.table_users.header.name"
                | translate
            }}
          </th>
          <th class="text-center" nzWidth="130px" style="min-width: 130px;">
            {{
              "enterprise_contract.panel_document.table_users.header.role"
                | translate
            }}
          </th>
          <th class="text-center"nzWidth="100px" style="min-width: 100px;">
            {{
              "enterprise_contract.panel_document.table_users.header.CTS"
                | translate
            }}
            <!--            {{-->
            <!--              "enterprise_contract.panel_document.table_users.header.role"-->
            <!--                | translate-->
            <!--            }}-->
          </th>
          <th class="text-center"nzWidth="100px" style="min-width: 100px;" *ngIf="checkShowImage">
            {{
              "enterprise_contract.panel_document.table_users.header.showImage"
                | translate
            }}

            <!--            {{-->
            <!--              "enterprise_contract.panel_document.table_users.header.role"-->
            <!--                | translate-->
            <!--            }}-->
          </th>
          <th   nzWidth="54px" style="min-width: 54px;">&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of editRowTable.data; let i = index" class="editable-row">
          <!-- TT -->
          <td class="text-center" *ngIf="data.role != 1">
            <nz-input-number class="td-nz-input" [(ngModel)]="data.order" (ngModelChange)="onChangeOrderApproveSign()" [nzMin]="1" [nzMax]="999"
                             [ngModelOptions]="{ standalone: true }"></nz-input-number>
          </td>
          <td class="text-center" *ngIf="data.role == 1">
            <nz-input-number class="td-nz-input" [(ngModel)]="data.order" (ngModelChange)="onChangeOrderApproveSign()" [nzMin]="1" [nzMax]="999"
                            disabled [ngModelOptions]="{ standalone: true }"></nz-input-number>
          </td>
          <!-- Tên -->
          <td>
            <div *ngIf="data.userId != null" class="editable-cell">
              {{ data.name }} - {{ data.email }} <span *ngIf="data.userPosition">- {{data.userPosition}}</span>
            </div>
          </td>

          <!-- Thực hiện -->
          <td class="text-center">
            <div *ngIf="data.userId != null">
              <nz-select [(ngModel)]="data.role" [ngModelOptions]="{ standalone: true }" style="width: 80%;" (ngModelChange)="changeRoleUserSign($event, data)">
                <nz-option [nzLabel]="'form.contract_approval' | translate" [nzValue]="'2'"></nz-option>
                <nz-option [nzLabel]="'form.contract_sign' | translate" [nzValue]="'1'"></nz-option>
              </nz-select>
            </div>
          </td>
          <td *ngIf="data.role != 1" class="td-nz-icon text-center" ><label
            nz-checkbox [(ngModel)]="data.CTS"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="changeCTS(data)"
          ></label></td>
          <td *ngIf=" data.role ==1">
          </td>
          <td class="td-nz-icon text-center" *ngIf="data.CTS && data.role != 1 && checkShowImage">
            <label nz-checkbox [(ngModel)]="data.showImage"
                   [ngModelOptions]="{ standalone: true }"
                   (ngModelChange)="changeChanKy(data)"></label>
            </td>
          <td class="td-nz-icon text-center" *ngIf="!data.CTS && data.role != 1 && checkShowImage" >
            <label nz-checkbox [(ngModel)]="data.showImage"
                   [ngModelOptions]="{ standalone: true }"
                 disabled  (ngModelChange)="changeChanKy(data)"></label>
          </td>
          <td *ngIf=" data.role ==1 && checkShowImage">
          </td>

          <!-- Action -->
          <td class="td-nz-icon text-center">
            <a (nzOnConfirm)="onClickDeleteElementRecordUser(data)" *ngIf="data.userId != null" nz-popconfirm
               nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}"
               nzPopconfirmTitle="{{
                  'popup.confirm_delete_user' | translate
                }}">
              <i aria-hidden="true" class="fa fa-trash" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
            </a>
          </td>
        </tr>
        <tr class="editable-row">
          <!-- TT -->
          <td class="text-center">&nbsp;</td>
          <!-- Tên -->
          <td>
            <div>
              <nz-input-group [nzSuffix]="suffixUserInput">
                <input #autocompleteInput (input)="onChangeUserSignSearch($event.target?.value)"
                       [(ngModel)]="inputUserValue" [ngModelOptions]="{ standalone: true }"
                       [nzAutocomplete]="autoUserSearching" id="inputUser" nz-input
                       placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}" />
                <nz-autocomplete #autoUserSearching>
                  <nz-auto-option (selectionChange)="autocompleteUserSelected($event, user)"
                                  *ngFor="let user of filteredUserOptions" [nzValue]="''">{{ user.name }}
                    -
                    {{ user.email }} <span *ngIf="user.userPosition">- {{user.userPosition}}</span></nz-auto-option>
                </nz-autocomplete>
              </nz-input-group>
              <ng-template #suffixUserInput>
                <nz-spin [nzIndicator]="indicatorUserInput" [nzSpinning]="isLoadUserSign" nzSimple></nz-spin>
              </ng-template>
              <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                                                  style="font-size: 24px"></i></ng-template>
            </div>
          </td>

          <td class="text-center">&nbsp;</td>

          <!-- Action -->

          <td class="td-nz-icon text-center">&nbsp;</td>
          <td class="td-nz-icon text-center">&nbsp;</td>
          <td class="td-nz-icon text-center" *ngIf="checkShowImage">&nbsp;</td>
        </tr>
        </tbody>
      </nz-table>
      <!--    <mat-error *ngIf="isValidNoUserExist || isValidExistingSigning">-->
      <!--      {{ "validation.error_user_no_set_up" | translate }}-->
      <!--    </mat-error>-->
    </form>
  </mat-expansion-panel>

</mat-dialog-content>
<mat-divider></mat-divider>
<div class="text-center mt-3">
  <button mat-stroked-button color="primary" class="mr-3"
          (click)="onNoClick()">
    <mat-icon class="mr-0">cancel</mat-icon>{{ "button.cancel" | translate }}
  </button>
  <button  mat-raised-button color="primary"  (click)="onsave()">
    <mat-icon class="mr-0">save</mat-icon>
    <span>{{"button.choose" | translate}}</span>
  </button>
</div>
